import React from 'react';
import '../template-file-css/document-file-template.css';


export const NHBC_PsychologicalTesingOrderForServices = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='NHBC_PsychologicalTesingOrderForServices' className='file-pdf-document'>

            <div className='file-template'>
                <h4>Non-Intensive Outpatient Services</h4>
                <p>
                    <strong>Psychological Testing</strong> (96130, 96131) <strong>(may include all modifiers and all practitioner levels)</strong>
                </p>
                <p className='w-750'>
                    <ul>
                        <li>Individual has a mental illness or a substance-related disorder and has
                            Recently entered the service system
                        </li>
                        <li>Individual is in need of annual assessment and re-authorization of
                            Service array; or
                        </li>
                        <li>Individual has a need of an assessment due to a change in
                            clinical/functional status
                        </li>
                    </ul>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Ordered By:</span>
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date Ordered:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="text" name="txtOrderedBy" id="txtOrderedBy" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <input type="date" name="txtDateOrdered" id="txtDateOrdered" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="signature w-275">&nbsp;</td>
                        <td className="signature w-275">&nbsp;</td>
                        <td className="signature w-200">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="small w-275">Signature</td>
                        <td className="small w-275">Credentials</td>
                        <td className="small w-200">Date</td>
                    </tr>
                </table>

            </div>
        </form>

    )
} 
